import objectHelper from "@/helpers/objectHelper";

export default class Consent {
  label = "";
  id = 0;
  validityPeriod = 0;

  constructor(data) {
    if (data) {
      objectHelper.assignOnlyExisting(this, data);
    }
  }
}
